import React from "react";
import {
  Card,
  CardContent,
  Container,
  Grid,
  Tab,
  Typography,
} from "@mui/material";
import PageLoader from "../../../compenents/app/PageLoader";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import { ChangePassword } from "./ChangePassword";

export default function CustomerProfilePage() {
  const customerId = useSelector(
    (state: AppState) => state.authReducer.customerData?.customerId
  );
  const [value, setValue] = React.useState("changePassword");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const theme = useTheme();
  return (
    <>
      <PageLoader isLoading={false}></PageLoader>

      <Container maxWidth={false}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          Setup Profile
        </Typography>
        <Card sx={{ minHeight: "50vh" }}>
          <CardContent>
            <Grid container>
              <TabContext value={value.toString()}>
                <Grid
                  item
                  xs={2}
                  sx={{
                    bgcolor: theme.palette.action.hover,
                    minHeight: "50vh",
                  }}
                >
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                    orientation="vertical"
                    sx={{ mt: 1 }}
                  >
                    <Tab
                      sx={{
                        backgroundColor:
                          value === "changePassword" ? "white" : "inherit",
                      }}
                      label="Change Password"
                      value="changePassword"
                    />
                  </TabList>
                </Grid>
                <Grid item xs={10}>
                  <TabPanel
                    value="changePassword"
                    sx={{ padding: 0, paddingLeft: 3 }}
                  >
                    <ChangePassword Id={customerId}></ChangePassword>
                  </TabPanel>
                </Grid>
              </TabContext>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </>
  );
}
